import {Action, Store, Middleware, ActionCreator, Dispatch} from 'redux';
import { ThunkAction } from 'redux-thunk';
import * as LoginActions from "../actions/LoginActions";
import * as Urls from '../component/Urls';
import * as Cookies from 'es-cookie';

export interface SystemLoginState{
	isLoading : boolean,
	errorMsg : string,
	userId : string,
	password : string
}

const initialState:SystemLoginState = {
	isLoading : false,
	errorMsg : "",
	userId : "",
	password : ""
}

export function loginReducer(state:SystemLoginState=initialState, action:LoginActions.LoginActions):SystemLoginState{
	let ret:SystemLoginState = Object.assign({}, state);

	switch(action.type){
		case LoginActions.LoginActionType.LOGIN:
			ret.isLoading=true;
			return ret;
		case LoginActions.LoginActionType.RESULT:
			ret.isLoading=false;
			ret.errorMsg=action.payload.errorMsg;
			return ret;
		case LoginActions.LoginActionType.CHANGE_USERID:
			ret.userId = action.payload.userId;
			return ret;
		case LoginActions.LoginActionType.CHANGE_PASSWD:
			ret.password = action.payload.password;
			return ret;
		default:
			return state;
	}
}

export const asyncLoginAction: ActionCreator<
	ThunkAction<Promise<Action>, SystemLoginState, void>
	> = (state : SystemLoginState) => {
		return async (dispatch: Dispatch<SystemLoginState>): Promise<Action> => {
		try {
			dispatch(LoginActions.getActionLogin());

			let form = new FormData();
			form.append("payload", JSON.stringify({
				user_id: state.userId,
				password: state.password
			}));
			
			let response: Response = await fetch(Urls.URL_LOGIN + "?execute",
			{
				method: 'POST',
				mode: 'cors',
				credentials: 'include',
				body: form
			});

			if(response.status == 200){
				/* クッキーへ保存 */
				let payload:any = await response.json();
				Cookies.set("userName", payload.tanto_name, {expires: 1});
				Cookies.set("userGrant", payload.is_admin, {expires: 1});
				window.location.href=Urls.URL_DASHBORD;
			}
			else if(response.status == 401){
				let payload:any = await response.json();
				return dispatch(LoginActions.getResultLogin(payload.errorMsg));
			}
		} catch (e) {
		}
	};
};
/*function timeout(ms:number) {
	return new Promise(resolve => setTimeout(resolve, ms));
}*/